import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getContractData, getContractTemplate, getTemplateContent, createContract, requestHigherDiscount, clientDetailsUpdateApi } from "../../../ReduxStore/Slice/Contract/contractSlice";
import { getEmailTemplate } from "../../../ReduxStore/Slice/Quote/CreateQuoteSlice";
import { upload_contract_attachment } from "../../../Service/Contract/contractService";
import Select from 'react-select';
import { useDispatch } from "react-redux";
import ReusableModal from "../../../ExtraComponents/ReusableModal";
import Loader from "../../../ExtraComponents/Loader";
import Swal from "sweetalert2";
import { agentList, agentDetails } from "../../../ReduxStore/Slice/Auth/AuthSlice";
import { getAllClient, getClientDetails } from "../../../Service/ThardPartyApi/ThardPartyAPI";

import {
  EMPTY_EMAIL_ERROR,
  EMPTY_SUBJECT_ERROR,
  EMPTY_SELECT_TEMPLET_ERROR,
  INVALID_EMAIL_ERROR,
  EMPTY_CC_EMAIL_ERROR,
  EMPTY_BCC_EMAIL_ERROR,
  INVALID_CC_EMAIL_ERROR,
  INVALID_BCC_EMAIL_ERROR,
  EMPTY_TEMPLET_BODY_ERROR
} from "../../../Utils/Common_Error";

import {
  ValidateEmail,
} from "../../../Utils/CommonFun";
import JoditEditor from 'jodit-react';
import * as Config from "../../../Utils/Config";
import axios from "axios";
import JSZip from "jszip";


const StepFour = ({ formData1, handleChange, nextStep, prevStep, currentStep }) => {

  // console.log("Stepfour rendered", formData1);

  const location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch();

  let ContractId = sessionStorage.getItem("contract_id");
  const editor = useRef(null);
  const userDetails = JSON.parse(localStorage.getItem("details"));
  if (location.state != undefined && location.state != null && location.state.record_id == undefined) {
    sessionStorage.setItem("contract_id", location.state.row.id);
    ContractId = location.state.row.id;
  }


  let backupQuoteId = ContractId;

  if (formData1 != undefined && formData1.contractid != undefined) {
    backupQuoteId = formData1.contractid;
  }

  if (location.state != null && location.state.row.id != undefined) {
    backupQuoteId = location.state.row.id;
  }

  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [quoteData, setQuoteData] = useState({});
  const [contractPackageServicesAll, setContractPackageServicesAll] = useState([]);
  const [allquotetemplate, setAllquotetemplate] = useState([]);
  const [agentListDataAuthorised, setAgentListDataAuthorised] = useState([]);
  const [agentListDataAuthorisedAll, setAgentListDataAuthorisedAll] = useState([]);
  const [complexityRiskPremium, setComplexityRiskPremium] = useState(0);


  console.log("contractPackageServicesAll", contractPackageServicesAll);


  const [allemailtemplate, setAllemailtemplate] = useState([]);
  const [content, setContent] = useState('');
  const [editorReady, setEditorReady] = useState(false);

  const [isModalPackageEffected, setIsModalPackageEffected] = useState(false);
  const [prevButtonStatus, setPrevButtonStatus] = useState(false)

  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [selectedAttachments, setSelectedAttachments] = useState([]);


  const [formData, setFormData] = useState({
    email_template_id: "",
    templateName: "",
    description: "",
    triggerEvent: "",
    subjectLine: "",
    bccEmail: "",
    replyTo: "",
    body: "",
    attachments: [],
  });

  const UpdateFormBody = useCallback((value) => {
    setFormData((prev) => {
      let updatedBody = prev.body.trim();

      const imgTag = `<img src="${value}" width="252" height="160" style="display: inline-block; margin-left: 5px; vertical-align: middle;"/>`;

      if (updatedBody.endsWith("<br>") || updatedBody.endsWith("</p>")) {
        updatedBody = updatedBody.replace(/(<br>|<\/p>)+$/, "");
      }

      updatedBody += ` ${imgTag}`;

      return { ...prev, body: updatedBody };
    });
  }, []);
  const cleanWordHtml = (html = "") => {
    if (!html) return html;

    html = html.replace(/<style[\s\S]*?<\/style>/gi, "");
    html = html.replace(/<!--[\s\S]*?-->/g, "");
    html = html.replace(/mso-[a-z\-]+\s*:[^;"]+(;|")/gi, "");
    html = html.replace(/<o:p>\s*<\/o:p>|<o:p>.*?<\/o:p>/gi, "");

    return html;
  };


  const config1 = useMemo(() => ({
    readonly: false,
    placeholder: "",
    buttons:
      "bold,italic,underline,strikethrough,ul,ol,indent,outdent,paragraph,fontsize,font,brush,link,image,video,table,align,undo,redo,cut,copy,paste,selectall,source",
    removeButtons: ["speechRecognize"],
    toolbarSticky: false,

    style: {
      font: '14px "Times New Roman", Arial, sans-serif',
      color: "#000000",
      lineHeight: "1.4",
    },

    controls: {
      font: {
        list: {
          Poppins: '"Poppins", sans-serif',
          Arial: "Arial, Helvetica, sans-serif",
          "Times New Roman": '"Times New Roman", Times, serif',
          Roboto: "Roboto, sans-serif",
          Verdana: "Verdana, Geneva, sans-serif",
        },
      },
    },

    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    defaultActionOnPaste: "insert_clear_html",
    defaultActionOnPasteFromWord: "insert_clear_html",

    processPasteHTML: (html) => {
      return cleanWordHtml(html);
    },

    processPasteFromWord: (html) => {
      return cleanWordHtml(html);
    },

    uploader: {
      url: Config.base_url + "img/uploader",
      accept: "image/*,video/*",
      method: "POST",
      withCredentials: false,
      prepareData: async (formData1) => {
        const data = new FormData();
        formData1.forEach((file) => {
          data.append("files[0]", file);
        });
        try {
          const response = await axios.post(Config.base_url + "img/uploader", data, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (response.data.success && Array.isArray(response.data.files) && response.data.files.length > 0) {
            UpdateFormBody(response.data.files[0]);
            return {
              success: true,
              files: response.data.files,
              messages: response.data.messages || ["Image uploaded successfully"],
            };
          } else {
            return {
              success: false,
              files: [],
              messages: ["Image upload failed"],
            };
          }
        } catch (error) {
          console.error("Image upload error:", error);
          return {
            success: false,
            files: [],
            messages: ["Image upload failed"],
          };
        }
      },
      defaultHandlerSuccess: (response) => {
        if (response?.files?.length > 0) {
          return response.files;
        } else {
          console.error("No files in response:", response);
          return [];
        }
      },
      defaultHandlerError: (error) => {
        console.error("Image upload error:", error);
        return [];
      },
    },
    events: {
      afterInit: (editorInstance) => {
        setEditorReady(true);
        editor.current = editorInstance;
      },
    },
  }), [UpdateFormBody]);



  const [selectedTemplate, setSelectedTemplate] = useState({
    mail_to: '',
    cc_to: "",
    bcc_to: "",
    subject: '',
    template_id: '',
    template_body: ''
  });
  const [hasPackage, setHasPackage] = useState(false);
  const [clientid, setClientid] = useState("");
  const [error, setError] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [templatePreviewContent, setTemplatePreviewContent] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [checkboxState, setCheckboxState] = useState({
    directorLetter: 0,
    selfAssessment: 0,
  });

  const [packageName, setPackageName] = useState("");
  const [package_id, setPackage_id] = useState("");
  const [emailAuthorised, setEmailAuthorised] = useState("");
  const [currentPackageDiscount, setCurrentPackageDiscount] = useState("");
  const [currentCost, setCurrentCost] = useState("");
  const [desiredHigherDiscount, setDesiredHigherDiscount] = useState(0);
  const [desiredPriceApproval, setDesiredPriceApproval] = useState(0);
  const [isCheckDirectorLetter, setIsCheckDirectorLetter] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [errorDiscount, setErrorDiscount] = useState(false);
  const [errorDiscountValue, setErrorDiscountValue] = useState(false);
  const [showHigherDiscountButton, setShowHigherDiscountButton] = useState(false);
  const [isAgentListLoading, setIsAgentListLoading] = useState(false);
  const [reasonHigherDiscount, setReasonHigherDiscount] = useState("");

  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [clientDetails, setClientDetails] = useState({});
  const [loading, setLoading] = useState(false)


  const textareaRef = useRef(null);
  const [templatestatus, setTemplatestatus] = useState(false)

  // console.log("errorDiscountValue", errorDiscountValue)


  const handleOpenModal = (templateId) => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    getAgentList();
  }, []);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
  }, [textareaRef?.current?.scrollHeight, reasonHigherDiscount]);




  const getAgentList = async () => {
    if (agent_id === null) return
    const req = { agent_id: agent_id }
    await dispatch(agentDetails(req)).unwrap()
      .then(async (res) => {
        if (res.status) {

          let agent_authorised_users = res.data.agent_authorised_users
          if (agent_authorised_users !== null) {

            // setAgentListDataAuthorised(JSON.parse(agent_authorised_users))
            // setEmailAuthorised(JSON.parse(agent_authorised_users)[0].user_email)
            const parsedAuthorisedUsers = JSON.parse(agent_authorised_users);

            const authorisedArray = Array.isArray(parsedAuthorisedUsers)
              ? parsedAuthorisedUsers
              : [parsedAuthorisedUsers];

            setAgentListDataAuthorised(authorisedArray);
            setAgentListDataAuthorisedAll(authorisedArray);
            // setEmailAuthorised(authorisedArray[0]?.user_email || "");

          } else {

            setAgentListDataAuthorised([])
            setAgentListDataAuthorisedAll([])

          }

        }
        else {
          setAgentListDataAuthorised([])
          setAgentListDataAuthorisedAll([])
        }


      })
      .catch((err) => {
        setAgentListDataAuthorised([])
        setAgentListDataAuthorisedAll([])
        console.log("Error", err)
      })
  }

  function cleanHtmlContent(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    const scripts = div.getElementsByTagName("script");
    const styles = div.getElementsByTagName("style");
    Array.from(scripts).forEach((script) => script.remove());
    Array.from(styles).forEach((style) => style.remove());
    const unorderedLists = div.querySelectorAll("ul");
    unorderedLists.forEach((list) => {
      list.style.listStyleType = "disc";
    });
    const orderedLists = div.querySelectorAll("ol");
    orderedLists.forEach((list) => {
      list.style.listStyleType = "decimal";
    });
    return div.innerHTML;

  }

  useEffect(() => {
    getQuote();
    getEmailTemplateFun();
    getQuoteAttachment();
  }, []);

  const ALLOWED_TYPES = {
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  };

  const extractZipAndSetAttachment = async (zipBlob) => {
    const zip = await JSZip.loadAsync(zipBlob);
    const attachments = [];

    for (const fileName of Object.keys(zip.files)) {
      const zipEntry = zip.files[fileName];

      // folder skip
      if (zipEntry.dir) continue;

      const ext = fileName.split(".").pop().toLowerCase();

      // sirf allowed files
      if (ALLOWED_TYPES[ext]) {
        const fileBlob = await zipEntry.async("blob");

        const file = new File([fileBlob], fileName, {
          type: ALLOWED_TYPES[ext], // 🔥 dynamic MIME type
          lastModified: Date.now(),
        });

        attachments.push(file);
      }
    }

    console.log("extracted attachments --", attachments);

    // EXACT file-input behaviour
    setFormData((prev) => ({
      ...prev,
      attachments,
    }));
  };

  const getQuoteAttachment = async () => {
    const req = { id: Number(ContractId), agent_id: agent_id, ongoing_onoff: 1, type: "attachment" };
    const res = await axios.post(
      Config.base_url + "get_contract",
      req,
      {
        responseType: "blob",
        validateStatus: () => true,
      }
    );

    console.log("getQuoteAttachment res -- ", res.status)
    // const blob = await res.data;

    // console.log("getQuoteAttachment blob -- ", blob)
    if (res.data.type === "application/json") {
      const text = await res.data.text();
      const json = JSON.parse(text);

      console.warn(json.message);
      return;
    }

    // 🔥 Safe to unzip
    await extractZipAndSetAttachment(res.data);
    // await extractZipAndSetAttachment(blob);



  };

  const getEmailTemplateFun = async () => {
    const req = { agent_id: agent_id, template_trriger_id: 2 };
    await dispatch(getEmailTemplate(req))
      .unwrap()
      .then(async (res) => {

        // console.log("res -- getEmailTemplate ", res);
        if (res.status) {
          if (res.data.length > 0) {
            setFormData({
              ...formData,
              email_template_id: res.data[0].id,
              body: res.data[0].body,
            });
          }
          setAllemailtemplate(res.data);
        } else {
          setAllemailtemplate([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const clientUpdateFunction = async () => {
    const req = { id: Number(ContractId), agent_id: agent_id, check: "getData" };
    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          // console.log("res.contract client ", res);
          const agent_db = localStorage.getItem('agent_db');
          const token_crm = localStorage.getItem('authClientToken');
          const agent_url = localStorage.getItem('agent_url');
          const company_id = JSON.parse(localStorage.getItem("company_id"));
          const req = {
            agent_db: agent_db,
            company_id: company_id,
            pricing_tool_pratice_id: agent_id,
            module: res.contract.Client.module_type,
            record_id: res.contract.Client.record_id || 0,
          };
          await getClientDetails(req, agent_url, token_crm).then(async (res) => {
            if (res.IsSuccess) {
              const req = {
                ClientDetails: res.result
              };

              await dispatch(clientDetailsUpdateApi(req)).unwrap()
                .then((res) => {
                  if (res.status) {
                  } else {

                  }
                })
                .catch((err) => {
                  console.log("err", err);
                });


            }

          }).catch((err) => {
            console.log("err", err);
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const getQuote = async () => {
    setIsLoading(true);

    await clientUpdateFunction();

    const req = { id: Number(ContractId), agent_id: agent_id };

    await dispatch(getContractData(req)).unwrap()
      .then(async (res) => {

        if (res.status) {
          // console.log("Final contract Data", res?.contract?.is_effected)
          if (Number(res?.contract?.is_effected) === 1) {
            setPrevButtonStatus(true);
            setIsModalPackageEffected(true);
          }


          setReasonHigherDiscount(res?.contract?.reason_higher_discount || "");
          if (Number(res?.contract?.higher_discount_status) == 0) {
            setShowHigherDiscountButton(true)
          }

          setClientid(res.contract.client_id)
          if (["COMPANY", "LLP"].includes((res.contract.EnquiryType.name).toUpperCase())) {
            setIsCheckDirectorLetter(true)
          }
          // setSelectedTemplate({
          //   ...selectedTemplate,
          //   mail_to: res.contract.Client.email,
          // })

          if (res.contract.ContractPackageServices != undefined && res.contract.ContractPackageServices != null && res.contract.ContractPackageServices.length > 0) {
            setContractPackageServicesAll(res.contract.ContractPackageServices)
          }
          setQuoteData(res.contract)
          setHasPackage(res.hasPackage)
          getQuoteTemplateFun(res.contract.Client.email, res.contract.client_id, res.contract.contact_owner);

          //console.log("res.contract", res.PackageDetails)

          let existpackageDetals = res.PackageDetails.ContractPackageServices.find((val) => val.Package != null)
          if (existpackageDetals != undefined && existpackageDetals != null) {
            setPackageName(existpackageDetals.Package.name)
            setPackage_id(existpackageDetals.Package.id)

            //  console.log("existpackageDetals", existpackageDetals)
            //  console.log("res.contract.discount_ongoing", res.contract)

            let complexity_risk_premium = parseFloat(res.contract.complexity_premium) + parseFloat(res.contract.risk_premium)



            if (Number(res.contract.status_discount_ongoing) == 1) {
              setCurrentPackageDiscount(res.contract.discount_ongoing)
              let currentCost = await currentCostFun(res.contract.discount_ongoing, res.contract.ContractPackageServices)
              setCurrentCost(currentCost)
            }


            if ((parseFloat(existpackageDetals.Package.default_discount) === parseFloat(res.contract.discount_ongoing)) && parseFloat(complexity_risk_premium) == 0 && parseFloat(res.contract.premium_ongoing) == 0) {
              setCurrentCost(existpackageDetals.Package.default_price)
            }

          } else {
            setPackageName("")
          }
        } else {
          setClientid('')
          setQuoteData({})
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
    // setIsLoading(false);
  };

  const getQuoteTemplateFun = async (email, client_id, contact_owner) => {
    const req = { id: Number(ContractId), agent_id: agent_id };
    await dispatch(getContractTemplate(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          setAllquotetemplate(res.data)
          if (res.data.length > 0) {
            setSelectedTemplate({
              ...selectedTemplate,
              mail_to: email,
              template_id: res.data[0].id,
              subject: res.data[0].subject
            })
            // await getTemplateContentFun(res.data[0].id, client_id, contact_owner);
            setTemplatestatus(true)
            setIsLoading(false);
          } else {
            setSelectedTemplate({
              ...selectedTemplate,
              mail_to: email,
              template_id: '',
              subject: ''
            })
            await Swal.fire({
              icon: "warning",
              title: "Warning",
              text: "Please create the contract template first",
              timer: 30000,
              timerProgressBar: true,
            });
            setIsLoading(false);
          }

        } else {
          setIsLoading(false);
          setAllquotetemplate([])
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  const selectValueOnChange = async (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "email_template_id") {
      const selectedTemplate = allemailtemplate.find(
        (template) => Number(template.id) === Number(value)
      );
      setFormData({
        ...formData,
        email_template_id: value,
        body: selectedTemplate ? selectedTemplate.body : "",
      });
      validate(name, value);
      return;
    }

    validate(name, value);
    setSelectedTemplate({
      ...selectedTemplate,
      [name]: value
    })
    if (name === 'template_id') {
      //  await getTemplateContentFun(value, quoteData?.client_id, quoteData?.contact_owner)
    }

  }

  const getTemplateContentFun = async (id, client_id, contact_owner) => {
    const req = { id: id, clientid: client_id, agent_id: agent_id, ContractOwner: contact_owner, quote_id: ContractId };
    setIsLoading(true);
    await dispatch(getTemplateContent(req)).unwrap()
      .then(async (res) => {
        if (res.status) {
          setTemplatePreviewContent(res.content)
          allquotetemplate && allquotetemplate?.find((val) => {
            if (Number(val.id) === Number(id)) {
              setSelectedTemplate({
                ...selectedTemplate,
                template_id: id,
                subject: val.subject
              })
            }
          })
          setIsLoading(false);
        } else {
          setTemplatePreviewContent('')
          setIsLoading(false);

        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
    setIsLoading(false);
  }

  const validate = async (name, value) => {
    const newErrors = { ...error };
    if (!value?.trim()) {
      if (name === "mail_to") newErrors[name] = EMPTY_EMAIL_ERROR;
      else if (name === "subject") newErrors[name] = EMPTY_SUBJECT_ERROR;
      else if (name === "template_id") newErrors[name] = EMPTY_SELECT_TEMPLET_ERROR;
      else if (name === "cc_to" || name === "bcc_to") {
        delete newErrors[name];
      }
      else if (name === "body") {
        newErrors[name] = EMPTY_TEMPLET_BODY_ERROR;
      }
    }
    // else if (name === "mail_to" && !/^[a-zA-Z0-9._%+-]+@(gmail|yahoo|outbooks|outbook|nomi|rediffmail|hotmail|outlook|aol|icloud|protonmail|example)\.(com|co\.in|in|net|org|edu|gov|uk|us|info|biz|io|...)[a-zA-Z]{0,}$/.test(value)) {
    //   newErrors[name] = INVALID_EMAIL_ERROR;
    // }
    else if (name === "mail_to") {
      let valid = await ValidateEmail(value)
      if (!valid) {
        newErrors[name] = INVALID_EMAIL_ERROR;
      } else {
        delete newErrors[name];
      }
    }



    // else if (name === "cc_to") {
    //   let valid = await ValidateEmail(value)
    //   if (!valid) {
    //     newErrors[name] = INVALID_CC_EMAIL_ERROR;
    //   } else {
    //     delete newErrors[name];
    //   }
    // }


    // else if (name === "bcc_to") {
    //   let valid = await ValidateEmail(value)
    //   if (!valid) {
    //     newErrors[name] = INVALID_BCC_EMAIL_ERROR;
    //   } else {
    //     delete newErrors[name];
    //   }
    // }


    else {
      delete newErrors[name];
    }
    setError(newErrors);
    return Object.keys(newErrors).length === 0 ? true : false;
  };

  let sendAttached = false
  const selectedAttachmentsStore = (data) => {
    sendAttached = true
    setSelectedAttachments(data)
    setShowAttachmentModal(false)
    // swal is confirm box
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to add this attachment?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleSubmit()
        // alert("Attachment added successfully!");
        // setShowAttachmentModal(true)
      }
      else {
        await handleSubmit('ignore')
        // alert("Attachment not added!");

      }
    })
  }

  const handleSubmit = async (type) => {

    // console.log("formData", formData.attachments)
    // console.log("selectedAttachments", selectedAttachments)

    let payment_type = 0
    if (quoteData.payment_term_oneoff != null && quoteData.payment_term_oneoff != "" && quoteData.payment_term_oneoff != undefined && (quoteData.payment_term_oneoff == "monthly_dd" || quoteData.payment_term_oneoff == "quarterly_dd")) {
      payment_type = 1
    }

    if (quoteData.payment_term_ongoing != null && quoteData.payment_term_ongoing != "" && quoteData.payment_term_ongoing != undefined && (quoteData.payment_term_ongoing == "monthly_dd" || quoteData.payment_term_ongoing == "quarterly_dd")) {
      payment_type = 1
    }



    let valid = true;
    if (!selectedTemplate.mail_to) {
      error.mail_to = EMPTY_EMAIL_ERROR;
      valid = false;
    }
    if (!selectedTemplate.subject) {
      error.subject = EMPTY_SUBJECT_ERROR;
      valid = false;
    }
    if (!selectedTemplate.template_id) {
      error.template_id = EMPTY_SELECT_TEMPLET_ERROR;
      valid = false;
    }

    setError({ ...error });


    if (valid) {

      // console.log("selectedAttachments", selectedAttachments)
      if (formData.attachments && formData.attachments.length > 0 && selectedAttachments.length == 0 && sendAttached == false) {
        setShowAttachmentModal(true)
        return
        // let reqAttached = { agent_id, agent_id, id: Number(ContractId), formData: formData, type: 'contract' };
        // await upload_contract_attachment(reqAttached)
      }

      if (selectedAttachments.length > 0 && type != 'ignore') {

        let reqAttached = {
          agent_id,
          id: Number(ContractId),
          formData: {
            ...formData,
            attachments: selectedAttachments,
          },
          type: "contract",
        };

        await upload_contract_attachment(reqAttached);
      }


      setDisableSubmit(true);
      setIsLoading(true);
      const req = {
        id: Number(ContractId),
        step: 4,
        mail_to: selectedTemplate.mail_to,
        subject: selectedTemplate.subject,
        template_id: selectedTemplate.template_id,
        clientid: clientid,
        ContractOwner: userDetails.id,
        agent_id: agent_id,
        director_letter: checkboxState.directorLetter,
        self_assessment: checkboxState.selfAssessment,
        payment_type: payment_type,
        cc_to: selectedTemplate.cc_to || "",
        bcc_to: selectedTemplate.bcc_to || "",
        email_template_details: formData,
        backupQuoteId: backupQuoteId

      }
      // setLoading(true);
      await dispatch(createContract(req)).unwrap()
        .then((res) => {
          // console.log("res createContract", res);
          if (res.status == true) {
            setIsLoading(false);
            sessionStorage.clear();
            navigate("/admin/contracts/contracts-dashboard");
            // setIsLoading(false);
            // Swal.fire({
            //   icon: "success",
            //   title: "Success",
            //   text: res.message,
            //   timer: 3000,
            //   timerProgressBar: true,
            // }).then(() => {
            //   sessionStorage.clear();
            //   navigate("/admin/contracts/contracts-dashboard");
            // });


          }
          else {

            setDisableSubmit(false);

            if (res.message.includes("_____________")) {

              Swal.fire({
                icon: "warning",
                title: "Warning..",
                text: "Signature Tag Is Missing In The Document.",
                timer: 3000,
                timerProgressBar: true,
              });
              return;
            } else {

              Swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                timer: 3000,
                timerProgressBar: true,
              })
              return;
            }

          }
        }).catch((err) => {
          setIsLoading(false);
          setDisableSubmit(false);
          console.log("err", err);
        })
    }
  }

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked ? 1 : 0,
    }));
  };

  const currentCostFun = async (discount, ContractPackageServices) => {
    let total_price = 0;
    if (discount == "") {
      return total_price
    }
    await ContractPackageServices.forEach(async (service) => {
      if (Number(service.service_type) == 1) {

        let price_afterdiscount = service.price - (service.price * discount) / 100;
        total_price += price_afterdiscount;
      }
    });
    return total_price;
  }

  const setDesiredHigherDiscountFun = async (e) => {
    let value = e.target.value;
    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      value = ""
      setDesiredHigherDiscount(value);
      let currentCost = await currentCostFun(value, quoteData && quoteData?.ContractPackageServices)
      setDesiredPriceApproval(currentCost)
      return
    }

    else if (value > 100) {
      value = 100;
    }

    if (parseFloat(value) <= parseFloat(currentPackageDiscount)) {
      setErrorDiscount(true)
    } else {
      setErrorDiscount(false)
    }

    setDesiredHigherDiscount(value);
    let currentCost = await currentCostFun(value, quoteData && quoteData?.ContractPackageServices)
    setDesiredPriceApproval(currentCost)
  }

  const desiredPriceApprovalFun = async (e) => {
    let value = e.target.value;

    if (value === '.') {
      value = "0.";
    }

    const isValid = /^\d*\.?\d*$/.test(value);
    if (isValid == false) {
      return
    }



    if (parseFloat(value) > parseFloat(currentCost)) {
      setDesiredHigherDiscount(0);
      setErrorDiscountValue(true);
    } else if (value === "") {
      setErrorDiscountValue(true);
    }
    else {

      let total_price = 0;
      await quoteData?.ContractPackageServices?.forEach(async (service) => {
        if (Number(service.service_type) == 1) {
          let price_afterdiscount = service.price;
          total_price += price_afterdiscount;
        }
      });
      const discountPercent = ((total_price - value) / total_price) * 100;
      setDesiredHigherDiscount(discountPercent.toFixed(2));
      setErrorDiscountValue(false);
    }
    setDesiredPriceApproval(value);

  }

  const [approvalErrors, setApprovalErrors] = useState({});


  const submitReqHigherDiscount = async (e) => {
    // if (parseFloat(desiredHigherDiscount || 0) <= parseFloat(currentPackageDiscount)) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Warning..",
    //     text: "Please Enter Higher Discount Than Current Discount",
    //     timer: 2000,
    //     timerProgressBar: true,
    //   });
    //   return;
    // }

    // if (errorDiscount == true) {
    //   return;
    // }




    if (errorDiscountValue == true) {
      return;
    }

    if (['', null, undefined].includes(emailAuthorised)) {

      Swal.fire({
        icon: "warning",
        title: "Warning..",
        text: "Please  Select Approval Email",
        timer: 5000,
        timerProgressBar: true,
      });
      return;

    }


    if (!['', null, undefined].includes(package_id)) {
      if (errorDiscountValue == true) {
        return;
      }
      if (parseFloat(desiredPriceApproval) === 0) {
        Swal.fire({
          icon: "warning",
          title: "Warning..",
          text: "Please Enter Desired Price Approval",
          timer: 5000,
          timerProgressBar: true,
        });
        return;
      }
    }

    let errorShow = Object.values(approvalErrors).every(value => value === '');

    if (!errorShow) {
      return
    }


    let req = {
      type: 1,
      contract_id: Number(ContractId),
      agent_id: agent_id,
      user_id: userDetails.id,
      client_id: clientid,
      email: emailAuthorised,
      package_id: package_id,
      current_discount: currentPackageDiscount,
      current_cost: currentCost,
      discount: desiredHigherDiscount || 0,
      cost: parseFloat(desiredPriceApproval),
      reason_higher_discount: reasonHigherDiscount,
    }

    if (currentCost == "" && package_id == "") {

      // let current_cost = contractPackageServicesAll && contractPackageServicesAll.length > 0 ? contractPackageServicesAll.reduce((sum, item) => sum + item.price, 0).toFixed(2) : 0


      // let cost = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? contractPackageServicesAll
      //     .reduce((sum, item) => {
      //       const price =
      //         item.approval_price !== undefined
      //           ? parseFloat(item.approval_price || 0)
      //           : item.price_afterdiscount;
      //       return sum + price;
      //     }, 0).toFixed(2) : 0


      // let current_discount = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? contractPackageServicesAll.find((item) => item.discount_rate)?.discount_rate : 0

      // let discount = (((current_cost || 0) - (cost || 0)) / (current_cost || 0)) * 100;


      // console.log("current_cost", current_cost)
      // console.log("cost", cost)
      // console.log("current_discount", current_discount)
      // console.log("discount", discount)






      // Calculate current_cost excluding BasisType.id === 2
      // let current_cost = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? contractPackageServicesAll.reduce((sum, item) => {
      //     const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;
      //     const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
      //       cb.ChargeBasis?.id === chargeBasisId &&
      //       cb.ChargeBasis?.BasisType?.id === 2
      //     );
      //     if (exclude) return sum;
      //     return sum + (item.price || 0);
      //   }, 0).toFixed(2)
      //   : 0;

      // // Calculate cost (approval_price or price_afterdiscount) excluding BasisType.id === 2
      // let cost = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? contractPackageServicesAll.reduce((sum, item) => {
      //     const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;
      //     const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
      //       cb.ChargeBasis?.id === chargeBasisId &&
      //       cb.ChargeBasis?.BasisType?.id === 2
      //     );
      //     if (exclude) return sum;
      //     const price = item.approval_price !== undefined
      //       ? parseFloat(item.approval_price || 0)
      //       : item.price_afterdiscount || 0;
      //     return sum + price;
      //   }, 0).toFixed(2)
      //   : 0;

      // // Get current_discount from first non-excluded item
      // let current_discount = contractPackageServicesAll && contractPackageServicesAll.length > 0
      //   ? (contractPackageServicesAll.find(item => {
      //     const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;
      //     const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
      //       cb.ChargeBasis?.id === chargeBasisId &&
      //       cb.ChargeBasis?.BasisType?.id === 2
      //     );
      //     return !exclude && item.discount_rate !== undefined;
      //   })?.discount_rate || 0)
      //   : 0;

      // // Calculate discount percentage
      // let discount = current_cost && cost
      //   ? (((parseFloat(current_cost) - parseFloat(cost)) / parseFloat(current_cost)) * 100).toFixed(2)
      //   : 0;


      const services = contractPackageServicesAll || [];

      const getChargeBasisId = (item) =>
        item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

      const isExcluded = (item) => {
        const chargeBasisId = getChargeBasisId(item);
        return chargeBasisId && item.Service?.ServiceChargeBases?.some(
          (cb) =>
            cb.ChargeBasis?.id === chargeBasisId &&
            cb.ChargeBasis?.BasisType?.id === 2
        );
      };

      // 👉 1. Calculate current_cost (based on item.price)
      const current_cost = services.reduce((sum, item) => {
        if (isExcluded(item)) return sum;
        return sum + (parseFloat(item.price) || 0);
      }, 0).toFixed(2);

      // 👉 2. Calculate cost (based on approval_price or price_afterdiscount)
      const cost = services.reduce((sum, item) => {
        if (isExcluded(item)) return sum;
        const price =
          item.approval_price !== undefined && item.approval_price !== null
            ? parseFloat(item.approval_price || 0)
            : parseFloat(item.price_afterdiscount || 0);
        return sum + price;
      }, 0).toFixed(2);

      // 👉 3. Get current_discount from first non-excluded item
      const current_discount = services.find((item) => {
        return !isExcluded(item) && item.discount_rate !== undefined;
      })?.discount_rate || 0;

      // 👉 4. Calculate discount percentage
      const discount =
        parseFloat(current_cost) && parseFloat(cost)
          ? (((parseFloat(current_cost) - parseFloat(cost)) / parseFloat(current_cost)) * 100).toFixed(2)
          : "0.00";


      // console.log("current_cost", current_cost)
      // console.log("cost", cost)
      // console.log("current_discount", current_discount)

      // console.log("discount", discount)



      req = {
        type: 2,
        contract_id: Number(ContractId),
        agent_id: agent_id,
        user_id: userDetails.id,
        client_id: clientid,
        email: emailAuthorised,
        current_discount: current_discount,
        current_cost: current_cost,
        discount: discount || 0,
        cost: cost,
        contractPackageServicesAll: contractPackageServicesAll,
        reason_higher_discount: reasonHigherDiscount,
      }

    }

    console.log("req ------>", req);
    return 
    setLoading(true)
    await dispatch(requestHigherDiscount(req)).unwrap()
      .then(async (res) => {

        if (res.status) {
          setDesiredHigherDiscount(0);
          setDesiredPriceApproval(0);
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Higher Discount Request Sent Successfully",
            timer: 4000,
            timerProgressBar: true,
          }).then(() => {
            setShowModal(false);
            //getQuote();
            sessionStorage.clear();
            navigate("/admin/contracts/contracts-dashboard");
          });

          // setDesiredHigherDiscount(0);
          // setDesiredPriceApproval(0);
          // setShowModal(false);
          // sessionStorage.clear();
          // navigate("/admin/contracts/contracts-dashboard");



        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            timer: 3000,
            timerProgressBar: true,
          });
        }

      })
      .catch((err) => {
        console.log("Error", err)
      }).finally(() => {
        setLoading(false);
      });
  }

  const getMaxApprovalDiscountValue = (data) => {
    if (!data?.length) return 0;
    let maxValue = 0;
    for (let i = 0; i < data.length; i++) {
      const value = Number(data[i].approval_discount) - Number(data[i].discount_rate) || 0;
      if (value > maxValue) {
        maxValue = value;
      }
    }
    return maxValue;
  };

  const getAuthorisedUsersByDiscount = (data, highestDiscount) => {
    if (!data?.length) return [];
    const result = [];
    for (let i = 0; i < data.length; i++) {
      const min = Number(data[i].min_discount) || 0;
      const max = Number(data[i].max_discount) || 0;
      if (highestDiscount >= min && highestDiscount <= max) {
        result.push(data[i]);
      }
    }
    return result;
  };




  const applyApprovalPrice = async (e, item, index) => {
    let value = e.target.value;

    const isValid = /^\d*\.?\d*$/.test(value);
    if (!isValid) return;

    if (parseFloat(value) > item.price) {
      setApprovalErrors(prevErrors => ({
        ...prevErrors,
        [index]: 'Approval price cannot be greater than original price.'
      }));
      return;
    }

    if (item.price_afterdiscount < parseFloat(value)) {
      setApprovalErrors(prevErrors => ({
        ...prevErrors,
        [index]: 'Approval price cannot be greater than discounted price.'
      }));
      return;
    }

    setApprovalErrors(prevErrors => ({
      ...prevErrors,
      [index]: ''
    }));


    ////////

    // console.log("setAgentListDataAuthorised", agentListDataAuthorised)




    const originalPrice = item.price;
    const approvalPrice = parseFloat(value || 0);
    const discount = ((originalPrice - approvalPrice) / originalPrice) * 100;

    const updatedServices = [...contractPackageServicesAll];
    updatedServices[index] = {
      ...updatedServices[index],
      approval_price: value,
      approval_discount: discount,
    };


    console.log("updatedServices", updatedServices)
    // set discount athorised user filter
    const highestDiscount = getMaxApprovalDiscountValue(updatedServices);
    const authoriseUser = getAuthorisedUsersByDiscount(agentListDataAuthorisedAll, highestDiscount);

    console.log("highestDiscount -->", highestDiscount)

    // const [emailAuthorised, setEmailAuthorised] = useState("");
    if (!["", null, undefined].includes(emailAuthorised)) {
      let isExistUser = authoriseUser?.find((val) => val.user_email === emailAuthorised);
      if (!isExistUser) {
        setEmailAuthorised("");
      }
    }

    setAgentListDataAuthorised(authoriseUser || []);
    setContractPackageServicesAll(updatedServices);
  }

  const viewPdfFunction = async (template) => {

    if (templatestatus === false) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please create the contract template first",
        timer: 20000,
        timerProgressBar: true,
      });
      return
    }


    const TemaplateName =
      allquotetemplate?.find(
        (val) => Number(val.id) === Number(template.template_id)
      )?.name || "Contract Template";

    setIsLoading(true);
    let payment_type = 0;

    if (
      quoteData.payment_term_oneoff &&
      (quoteData.payment_term_oneoff === "monthly_dd" ||
        quoteData.payment_term_oneoff === "quarterly_dd")
    ) {
      payment_type = 1;
    }

    if (
      quoteData.payment_term_ongoing &&
      (quoteData.payment_term_ongoing === "monthly_dd" ||
        quoteData.payment_term_ongoing === "quarterly_dd")
    ) {
      payment_type = 1;
    }

    const req = {
      id: Number(ContractId),
      step: 4,
      mail_to: selectedTemplate.mail_to,
      subject: selectedTemplate.subject,
      template_id: selectedTemplate.template_id,
      clientid: clientid,
      ContractOwner: userDetails.id,
      agent_id: agent_id,
      director_letter: checkboxState.directorLetter,
      self_assessment: checkboxState.selfAssessment,
      payment_type: payment_type,
      cc_to: selectedTemplate.cc_to || "",
      bcc_to: selectedTemplate.bcc_to || "",
      email_template_details: formData,
      view_pdf: true,
      backupQuoteId: backupQuoteId
    };

    try {
      const res = await dispatch(createContract(req)).unwrap();
      if (res.status) {
        const base64String = res.data;
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        const blobUrl = URL.createObjectURL(blob);

        setPdfUrl(blobUrl);
        setShowPdfModal(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res.msg,
          timer: 9000,
          timerProgressBar: true,
        });
      }

    } catch (err) {
      console.log("Error", err);
      setIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to generate PDF. Please try again.",
        timer: 5000,
        timerProgressBar: true,
      });
    }

  };


  const handleAttachmentChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData({
      ...formData,
      attachments: [...formData.attachments, ...files],
    });
  };

  const handleRemoveAttachment = (index) => {
    const updatedAttachments = formData.attachments.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, attachments: updatedAttachments });
  };


  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: '',
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'transparent',
        backdrop: 'rgba(229, 233, 236, 0.2)',
        // timer: null,
        customClass: {
          popup: 'no-shadow',
        }
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tdStyle = {
    padding: "8px",
    borderBottom: "1px solid #eee",
  };

  const inputStyle = {
    width: "90px",
    borderRadius: "20px",
    border: "1px solid #ccc",
    padding: "4px 8px",
    textAlign: "center",
  };


  return (

    <div>
      <div className="row mb-4">
        <div className="col">
          <h4 className="page-title" >
            <i className='bx bx-arrow-back text-pink pe-1' onClick={() => prevStep(false)}></i>

            New Contract{" "}
            <span>
              {" "}

            </span>
          </h4>
        </div>
      </div>




      <div className="card pt-4">
        <div className="card-body">
          <div className="row">
            <div className="col-lg-3">
              <h4 className="card-title mb-4">Send Contract</h4>
            </div>
            <div className="col-lg-5 row">
              {
                isCheckDirectorLetter ? (
                  <div className="col-lg-6">
                    <input
                      type="checkbox"
                      name="directorLetter"
                      className="form-check-input mx-2"
                      checked={checkboxState.directorLetter === 1}
                      onChange={handleCheckboxChange}
                    />
                    <label className="form-label">Director Letter</label>
                  </div>
                ) : ""
              }

              <div className="col-lg-6">
                <input
                  type="checkbox"
                  name="selfAssessment"
                  className="form-check-input mx-2"

                  checked={checkboxState.selfAssessment === 1}
                  onChange={handleCheckboxChange}
                />
                <label className="form-label">Self Assessment</label>
              </div>
            </div>


            {
              showHigherDiscountButton ?
                <div className="col-lg-4">
                  {/* <div className="offset-lg-4">
                    <button className="btn btn-pink" onClick={() => setShowModal(true)}>Request Higher Discount</button>
                  </div> */}
                </div>
                : ""
            }


          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Mail To
                </label>
                <input
                  type="text"
                  name="mail_to"
                  className="form-control"
                  id="exampleInputEmail1"
                  disabled={true}
                  onChange={(e) => selectValueOnChange(e)}
                  value={selectedTemplate.mail_to}
                />
                {error.mail_to && (
                  <p className="text-danger">{error.mail_to}</p>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  CC
                </label>
                <input
                  type="text"
                  name="cc_to"
                  className="form-control"
                  id="exampleInputEmail1"
                  onChange={(e) => selectValueOnChange(e)}
                  value={selectedTemplate.cc_to}
                />
                {error.cc_to && (
                  <p className="text-danger">{error.cc_to}</p>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  BCC
                </label>
                <input
                  type="text"
                  name="bcc_to"
                  className="form-control"
                  id="exampleInputEmail1"
                  onChange={(e) => selectValueOnChange(e)}
                  value={selectedTemplate.bcc_to}
                />
                {error.bcc_to && (
                  <p className="text-danger">{error.bcc_to}</p>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Select Email Template
                </label>
                <select
                  className="form-select"
                  name="email_template_id"
                  onChange={(e) => selectValueOnChange(e)}
                >
                  {allemailtemplate && allemailtemplate?.map((val, index) => (
                    <option
                      key={index}
                      value={val.id}
                      selected={val.id === formData.email_template_id}
                    >
                      {val.name}
                    </option>
                  ))}
                </select>
                {/* {error.template_id && (
                                  <p className="text-danger">{error.template_id}</p>
                                )} */}
              </div>
            </div>

            <div className="col-md-12">
              <div className="row">

                <label for="exampleInputEmail1" className="form-label">
                  Body
                </label>
                <div className="col-sm-12">
                  <JoditEditor
                    ref={editor}
                    config={config1}
                    tabIndex={1}
                    onBlur={(newContent) => setContent(newContent)}
                    name="body"
                    onChange={(value) => {
                      setFormData({ ...formData, body: value });
                      validate("body", value);
                    }}
                    value={formData.body || ""}
                  />
                  {error.body && <div className="error-text">{error.body}</div>}

                </div>
              </div>
            </div>


            <div className="col-md-12 mt-3">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  className="form-control"
                  id="exampleInputEmail1"
                  onChange={(e) => selectValueOnChange(e)} value={selectedTemplate.subject} />
              </div>
              {error.subject && (
                <p className="text-danger">{error.subject}</p>
              )}
            </div>
            <div className="col-md-12">
              <div className="mb-3">
                <label for="exampleInputEmail1" className="form-label">
                  Select PDF Template
                </label>
                <select className="form-select"
                  name="template_id"
                  onChange={(e) => selectValueOnChange(e)}
                  value={selectedTemplate.template_id}
                >
                  {
                    allquotetemplate?.map((val, index) => (
                      <option key={index}
                        value={val.id}
                        selected={val.id === selectedTemplate.template_id}
                      >
                        {val.name}
                      </option>
                    ))

                  }
                </select>
                {error.template_id && (
                  <p className="text-danger">{error.template_id}</p>
                )}

                {/* <a
                  href="#"
                  className="mt-2 d-block text-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenModal(selectedTemplate.template_id);
                  }}
                >
                  Preview Template
                </a> */}

                <a
                  href="#"
                  className="mt-2 d-block text-primary"
                  onClick={(e) => {
                    e.preventDefault();
                    viewPdfFunction(selectedTemplate);
                  }}
                >
                  Preview PDF
                </a>

                {showPdfModal && (
                  <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl" role="document">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">PDF Preview</h5>

                          {/* Open in New Tab Button */}
                          <a
                            href={pdfUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-pink ms-2 btn-sm"
                            style={{ fontSize: '10px' }}
                          >
                            Open in New Tab
                          </a>

                          {/* Close Button */}
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowPdfModal(false)}
                          ></button>
                        </div>

                        <div className="modal-body">
                          <iframe
                            src={pdfUrl}
                            title="PDF Preview"
                            width="100%"
                            height="600px"
                            style={{ border: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                )}

              </div>
            </div>


            <div className="col-sm-9">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => document.getElementById("fileInput").click()}
              >
                <i className="bi bi-paperclip me-2"></i>
                Add Attachment
              </button>
              <input
                id="fileInput"
                type="file"
                multiple
                accept=".pdf,.doc,.docx"
                onChange={handleAttachmentChange}
                className="d-none"
              />
              <div className="attachment-list mt-3">
                {formData?.attachments?.map((file, index) => (
                  <div
                    key={index}
                    className="attachment-item d-flex align-items-center justify-content-between mb-2 p-2"
                  >
                    <div className="d-flex align-items-center gap-2">
                      <div className="file-icon">
                        <i className="bi bi-paperclip"></i>
                      </div>

                      <span className="file-name">{file?.name}</span>
                    </div>

                    <button
                      type="button"
                      className="btn btn-sm btn-light-danger remove-btn"
                      onClick={() => handleRemoveAttachment(index)}
                    >
                      <i className="bi bi-x-lg"></i>
                    </button>
                  </div>
                ))}
              </div>

            </div>


          </div>

          <div className="d-flex justify-content-between mt-3">
            {currentStep > 1 && (
              <button
                className="btn btn-secondary"
                onClick={() => prevStep(false)}
                disabled={prevButtonStatus}
              >
                Previous
              </button>
            )}
            <button
              disabled={disableSubmit}
              className="btn btn-pink"
              onClick={handleSubmit}
            >
              {currentStep < 4 ? "Next" : "Send"}
            </button>
          </div>
        </div>
      </div>


      {isModalOpen && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Template Preview</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>

              <div
                className="modal-body preview-body"
                dangerouslySetInnerHTML={{ __html: templatePreviewContent || "" }}
                readOnly
              />
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {
        packageName !== "" ?
          <>
            {/* package request higher discount modal  */}
            <ReusableModal
              show={showModal}
              onClose={() => setShowModal(false)}
              modalsize="lg"
              title={
                <span className="text-pink fw-bold" style={{ fontWeight: "600", fontSize: "20px" }}>Request Higher Discount</span>
              }
              body={
                <>
                  <div className="p-3 rounded">
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Approved By:</label>
                      </div>

                      <div className="col-md-8">
                        <select
                          className="form-select"
                          onChange={(e) => { setEmailAuthorised(e.target.value) }}
                        >
                          <option value=""> -- Select -- </option>
                          {agentListDataAuthorised && agentListDataAuthorised?.map((val, index) => (
                            <option
                              key={index}
                              value={val?.user_email}
                              selected={val?.user_email === emailAuthorised}
                            >

                              {val?.user_fname + ' ' + val?.user_lname}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Package:</label>
                      </div>
                      <div className="col-md-8">
                        <input
                          disabled
                          className="form-control"
                          value={packageName && packageName}
                        />
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Current Package Discount (%):</label>

                      </div>
                      <div className="col-md-8">
                        <input
                          disabled
                          className="form-control"
                          value={currentPackageDiscount && currentPackageDiscount + '%'}
                        />

                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Current Cost:</label>

                      </div>
                      <div className="col-md-8">
                        <input
                          disabled
                          className="form-control"
                          value={currentCost && '£' + currentCost.toFixed(2)}
                        />

                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Desired Higher Discount (%):</label>
                      </div>
                      <div className="col-md-8">
                        <input
                          disabled
                          className="form-control"
                          type="text"
                          max={100}
                          value={desiredHigherDiscount && desiredHigherDiscount + '%'}
                          onChange={(e) => {
                            setDesiredHigherDiscountFun(e);
                          }}
                        />

                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label className="form-label">Desired Price for Approval:</label>

                      </div>
                      <div className="col-md-8">
                        <input
                          className="form-control"
                          type="text"
                          value={desiredPriceApproval}
                          onChange={(e) => desiredPriceApprovalFun(e)}
                        />
                        {
                          desiredPriceApproval === "" ?
                            <span className="text-danger">Please enter desired price for approval</span> :
                            errorDiscountValue ? <span className="text-danger">Desired Price can not be greater than current cost {currentCost.toFixed(2)}</span> : ""
                        }
                      </div>
                    </div>

                    <div className="row mb-3">
                      <label className="col-sm-4 col-md-2 col-form-label">
                        <strong>Reason:</strong>
                      </label>
                      <div className="col-sm-8 col-md-10 ">
                        <textarea
                          ref={textareaRef}
                          value={reasonHigherDiscount}
                          name="reason_higher_discount"
                          onChange={(e) => setReasonHigherDiscount(e.target.value)}
                          placeholder="Please Enter Reason For Higher Discount"
                          style={{
                            width: "100%",
                            minHeight: "40px",
                            maxHeight: "300px",
                            overflowY: "hidden",
                            padding: "8px",
                            fontSize: "16px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              }
              footer={
                <>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-pink" onClick={(e) => submitReqHigherDiscount(e)}
                    disabled={loading}
                  >{loading ? "Submitting..." : "Submit"}</button>
                </>
              }
            />
          </>

          :

          <>
            {/* Only Service request higher discount modal  */}
            {/* <ReusableModal
              show={showModal}
              onClose={() => setShowModal(false)}
              modalsize="xl"
              title={
                <span className="text-pink fw-bold" style={{ fontWeight: "600", fontSize: "20px" }}>Request Higher Discount Services</span>
              }
              body={
                <>
                  <div className="p-3 rounded">
                    <div className="row mb-3">
                      <div className="col-md-4"> <div className="row mb-3">
                        <div className="col-md-6">
                          <label className="form-label">Approved By:</label>
                        </div>
                        <div className="col-md-6">
                          <select className="form-select" onChange={(e) => { setEmailAuthorised(e.target.value) }}>
                            {agentListDataAuthorised && agentListDataAuthorised?.map((val, index) => (
                              <option
                                key={index}
                                value={val?.user_email}
                                selected={val?.user_email === emailAuthorised}
                              >

                                {val?.user_fname + ' ' + val?.user_lname}</option>
                            ))}
                          </select>
                        </div>
                      </div></div>

                      <div className="col-md-4"> <div className="row mb-3">
                        <div className="col-md-10">
                          <p className="form-label">
                            Total Current Price : &pound;
                            {
                              contractPackageServicesAll && contractPackageServicesAll.length > 0
                                ? contractPackageServicesAll.reduce((sum, item) => {
                                  const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                  const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
                                    cb.ChargeBasis?.id === chargeBasisId &&
                                    cb.ChargeBasis?.BasisType?.id === 2
                                  );

                                  return exclude ? sum : sum + (item.price_afterdiscount || 0);
                                }, 0).toFixed(2)
                                : 0
                            }
                          </p>
                        </div>
                      </div></div>
                      <div className="col-md-4">  <div className="row mb-3">
                        <div className="col-md-12">
                         
                          <label className="form-label">
                            Total Price For Approval: &pound;
                            
                            {
                              contractPackageServicesAll && contractPackageServicesAll.length > 0
                                ? contractPackageServicesAll.reduce((sum, item) => {
                                  const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                  const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
                                    cb.ChargeBasis?.id === chargeBasisId &&
                                    cb.ChargeBasis?.BasisType?.id === 2
                                  );

                                  if (exclude) return sum;

                                  const price =
                                    item.approval_price !== undefined && item.approval_price !== null
                                      ? parseFloat(item.approval_price || 0)
                                      : item.price_afterdiscount;

                                  return sum + price;
                                }, 0).toFixed(2)
                                : 0
                            }

                          </label>
                        </div>
                      </div></div>

                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4">
                        <div className="row mb-3">
                          <div className="col-md-10">
                            <label className="form-label">Package Name  :  Custom</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="table-responsive">
                        <table className="table  table-nowrap">
                          <thead>
                            <tr>
                              <th scope="col">Service Name</th>
                              <th scope="col">Price</th>
                              <th scope="col">Discounted Price</th>
                              <th scope="col">Current  Discount (%)</th>
                              <th scope="col">Approval Discount (%)</th>
                              <th scope="col">Approval Price</th>
                            </tr>
                          </thead>
                          <tbody>
                            
                            {
                              contractPackageServicesAll &&
                              contractPackageServicesAll.map((val, index) => {
                                const isValidChargeBasis = val.Service?.ServiceChargeBases?.some(cb =>
                                  cb.ChargeBasis &&
                                  cb.ChargeBasis.id === val.sell_chargebasis_id &&
                                  cb.ChargeBasis.basistypes_id === 2
                                );

                                return val.Package == null ? (
                                  <tr key={index}>
                                    <td>
                                      {isValidChargeBasis ? val.Service.name + "(Hourly)" : val.Service.name}
                                    </td>
                                    <td>£{val.price.toFixed(2)}</td>
                                    <td>£{val.price_afterdiscount.toFixed(2)}</td>
                                    <td>{

                                      isValidChargeBasis ?
                                        "-"
                                        :
                                        val.discount_rate.toFixed(2)

                                    }</td>
                                    <td>

                                      {
                                        isValidChargeBasis ?
                                          "-"
                                          :
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={val.approval_discount != undefined ? val.approval_discount.toFixed(2) : val.discount_rate}
                                            disabled
                                          />

                                      }


                                    </td>
                                    <td>

                                      <input
                                        type="text"
                                        className="form-control"
                                        value={val.approval_price != undefined ? val.approval_price : val.price_afterdiscount.toFixed(2)}
                                        onChange={(e) => applyApprovalPrice(e, val, index)}
                                      />
                                      {approvalErrors[index] && (
                                        <div className="text-danger mt-1">{approvalErrors[index]}</div>
                                      )}
                                    </td>
                                  </tr>
                                ) : null;
                              })
                            }


                          </tbody>
                        </table>
                      </div>
                    </div>




                    <div className="row mb-3">
                      <label className="col-sm-4 col-md-2 col-form-label">
                        <strong>Reason:</strong>
                      </label>
                      <div className="col-sm-8 col-md-10 ">
                        <textarea
                          ref={textareaRef}
                          value={reasonHigherDiscount}
                          name="reason_higher_discount"
                          onChange={(e) => setReasonHigherDiscount(e.target.value)}
                          placeholder="Please Enter Reason For Higher Discount"
                          style={{
                            width: "100%",
                            minHeight: "40px",
                            maxHeight: "300px",
                            overflowY: "hidden",
                            padding: "8px",
                            fontSize: "16px",
                            borderRadius: "5px",
                            border: "1px solid #ccc",
                          }}
                        />
                      </div>
                    </div>

                  </div>


                </>
              }
              footer={
                <>
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => setShowModal(false)}>
                    Cancel
                  </button>
                  <button className="btn btn-pink"
                    onClick={(e) => submitReqHigherDiscount(e)}
                    disabled={loading}
                  > {loading ? "Submitting..." : "Submit"}</button>
                </>
              }
            /> */}




            <ReusableModal
              show={showModal}
              onClose={() => setShowModal(false)}
              modalsize="xl"
              modalContentClass="higher-discount-content"


              body={
                <div style={{ background: "#fff", padding: "10px 20px" }}>
                  <div> <h4 className="text-pink text-center">Request Higher Discount Services</h4></div>
                  <div style={{
                    fontSize: "14px",
                    textAlign: "center",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "20px",
                    marginBottom: "14px"
                  }}>
                    <strong>Package Name :</strong> Custom
                  </div>



                  {/* Top Summary Section */}
                  <div>

                    {/* Approved By */}
                    <div className="appo-by">
                      <label className="me-2" style={{ fontWeight: "500" }}>Approved By : </label>
                      <select
                        value={emailAuthorised}
                        onChange={(e) => setEmailAuthorised(e.target.value)}
                        style={{
                          padding: "4px 10px",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                        }}
                      >
                        <option value=""> -- Select -- </option>
                        {agentListDataAuthorised?.map((val, index) => (
                          <option key={index} value={val?.user_email}>
                            {val?.user_fname + " " + val?.user_lname}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* Price Summary */}
                    <div className="d-flex justify-content-between">

                      {
                        contractPackageServicesAll?.find((item) => Number(item.service_type) === 1) ?
                          <div style={{ display: "flex", gap: "30px", fontSize: "14px", }}>
                            <span>
                              <strong>Total Current Pricing :</strong> £
                              {contractPackageServicesAll?.length > 0
                                ? contractPackageServicesAll?.filter((item) => Number(item.service_type) === 1)
                                  .reduce((sum, item) => {
                                    const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                    const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
                                      cb.ChargeBasis?.id === chargeBasisId &&
                                      cb.ChargeBasis?.BasisType?.id === 2
                                    );

                                    return exclude ? sum : sum + (item.price_afterdiscount || 0);
                                  }, 0).toFixed(2)
                                : 0
                              }

                            </span>

                            <span>
                              <strong>Total Pricing For Approval :</strong> £
                              {contractPackageServicesAll?.length > 0
                                ? contractPackageServicesAll?.filter((item) => Number(item.service_type) === 1)
                                  .reduce((sum, item) => {
                                    const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                    const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
                                      cb.ChargeBasis?.id === chargeBasisId &&
                                      cb.ChargeBasis?.BasisType?.id === 2
                                    );

                                    if (exclude) return sum;

                                    const price =
                                      item.approval_price !== undefined && item.approval_price !== null
                                        ? parseFloat(item.approval_price || 0)
                                        : item.price_afterdiscount;

                                    return sum + price;
                                  }, 0).toFixed(2)
                                : 0
                              }
                            </span>
                          </div>
                          : ""

                      }


                      {
                        contractPackageServicesAll?.find((item) => Number(item.service_type) === 0) ?
                          <div style={{ display: "flex", gap: "30px", fontSize: "14px", }}>
                            <span>
                              <strong>Total Current Pricing :</strong> £
                              {
                                contractPackageServicesAll?.length > 0
                                  ? contractPackageServicesAll?.filter((item) => Number(item.service_type) === 0).reduce((sum, item) => {
                                    const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                    const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
                                      cb.ChargeBasis?.id === chargeBasisId &&
                                      cb.ChargeBasis?.BasisType?.id === 2
                                    );

                                    return exclude ? sum : sum + (item.price_afterdiscount || 0);
                                  }, 0).toFixed(2)
                                  : 0
                              }
                            </span>

                            <span>
                              <strong>Total Pricing For Approval :</strong> £
                              {contractPackageServicesAll?.length > 0
                                ? contractPackageServicesAll?.filter((item) => Number(item.service_type) === 0).reduce((sum, item) => {
                                  const chargeBasisId = item.sell_chargebasis_id || item?.Service?.default_chargebasis_id;

                                  const exclude = chargeBasisId && item.Service?.ServiceChargeBases?.some(cb =>
                                    cb.ChargeBasis?.id === chargeBasisId &&
                                    cb.ChargeBasis?.BasisType?.id === 2
                                  );

                                  if (exclude) return sum;

                                  const price =
                                    item.approval_price !== undefined && item.approval_price !== null
                                      ? parseFloat(item.approval_price || 0)
                                      : item.price_afterdiscount;

                                  return sum + price;
                                }, 0).toFixed(2)
                                : 0
                              }
                            </span>
                          </div>
                          : ""

                      }


                    </div>

                  </div>

                  {/* Package Name */}


                  {/* ===== 2 PARTITION SERVICES ===== */}
                  {(() => {
                    // const filtered =contractPackageServicesAll?.filter(
                    //          (val) => val.Package == null 
                    //          ) || [];
                    // const mid = Math.ceil(filtered.length / 2);
                    // const left = filtered.slice(0, mid);
                    // const right = filtered.slice(mid);

                    const left = contractPackageServicesAll?.filter(
                      (val) => Number(val?.service_type) === 1
                    ) || [];

                    const right = contractPackageServicesAll?.filter(
                      (val) => Number(val?.service_type) === 0
                    ) || [];


                    return (
                      <div style={{ marginTop: "15px", display: left.length > 0 && right.length > 0 ? "flex" : "", gap: "10px" }}>

                        {/* LEFT TABLE */}
                        {
                          left.length > 0 ?
                            <div style={{ flex: 1 }}>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  fontSize: "13px",
                                }}
                              >
                                <thead>
                                  <tr style={{ background: "#fafafa" }}>
                                    {[
                                      "Service Name",
                                      "Price",
                                      "Discounted Price",
                                      "Current Discount (%)",
                                      "Approval Discount (%)",
                                      "Approval Price",
                                    ].map((heading, i) => (
                                      <th
                                        key={i}
                                        style={{
                                          padding: "8px",
                                          borderBottom: "1px solid #ddd",
                                          textAlign: "left",
                                        }}
                                      >
                                        {heading}
                                      </th>
                                    ))}
                                  </tr>
                                </thead>

                                <tbody>
                                  {left?.map((val, index) => (
                                    <tr key={val.id}>
                                      <td style={tdStyle}>{val.Service.name}</td>
                                      <td style={tdStyle}>£{val.price.toFixed(2)}</td>
                                      <td style={tdStyle}>
                                        £{val.price_afterdiscount.toFixed(2)}
                                      </td>
                                      <td style={tdStyle}>
                                        {val.discount_rate.toFixed(2)}
                                      </td>
                                      <td style={tdStyle}>
                                        <input
                                          disabled
                                          value={
                                            val.approval_discount != undefined
                                              ? val.approval_discount.toFixed(2)
                                              : val.discount_rate
                                          }
                                          style={inputStyle}
                                        />
                                      </td>
                                      <td style={tdStyle}>
                                        <input
                                          type="number"
                                          value={
                                            val.approval_price != undefined
                                              ? val.approval_price
                                              : val.price_afterdiscount
                                          }
                                          onChange={(e) =>
                                            applyApprovalPrice(
                                              e,
                                              val,
                                              contractPackageServicesAll.findIndex(
                                                (s) => s.id === val.id
                                              )
                                            )
                                          }
                                          style={inputStyle}
                                        />
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            : ""
                        }


                        {/* Divider */}
                        <div style={{ width: "1px", background: "#ddd" }} />

                        {/* RIGHT TABLE */}
                        {
                          right.length > 0 ?
                            <div style={{ flex: 1 }}>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  fontSize: "13px",
                                }}
                              >
                                <thead>
                                  <tr style={{ background: "#fafafa" }}>
                                    {[
                                      "Service Name",
                                      "Price",
                                      "Discounted Price",
                                      "Current Discount (%)",
                                      "Approval Discount (%)",
                                      "Approval Price",
                                    ].map((heading, i) => (
                                      <th
                                        key={i}
                                        style={{
                                          padding: "8px",
                                          borderBottom: "1px solid #ddd",
                                          textAlign: "left",
                                        }}
                                      >
                                        {heading}
                                      </th>
                                    ))}
                                  </tr>
                                </thead>

                                <tbody>
                                  {right?.map((val, index) => (
                                    <tr key={val.id}>
                                      <td style={tdStyle}>{val.Service.name}</td>
                                      <td style={tdStyle}>£{val.price.toFixed(2)}</td>
                                      <td style={tdStyle}>
                                        £{val.price_afterdiscount.toFixed(2)}
                                      </td>
                                      <td style={tdStyle}>
                                        {val.discount_rate.toFixed(2)}
                                      </td>
                                      <td style={tdStyle}>
                                        <input
                                          disabled
                                          value={
                                            val.approval_discount != undefined
                                              ? val.approval_discount.toFixed(2)
                                              : val.discount_rate
                                          }
                                          style={inputStyle}
                                        />
                                      </td>
                                      <td style={tdStyle}>
                                        <input
                                          type="number"
                                          value={
                                            val.approval_price != undefined
                                              ? val.approval_price
                                              : val.price_afterdiscount
                                          }
                                          onChange={(e) =>
                                            applyApprovalPrice(
                                              e,
                                              val,
                                              contractPackageServicesAll.findIndex(
                                                (s) => s.id === val.id
                                              )
                                            )
                                          }
                                          style={inputStyle}
                                        />
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            : ""
                        }

                      </div>
                    );
                  })()}

                  {/* ===== SINGLE REASON ===== */}
                  <div style={{ marginTop: "25px" }}>
                    <label style={{ fontWeight: "600" }}>Reason:</label>
                    <textarea
                      value={reasonHigherDiscount}
                      onChange={(e) => setReasonHigherDiscount(e.target.value)}
                      placeholder="Please Enter Reason For Higher Discount"
                      style={{
                        width: "100%",
                        marginTop: "8px",
                        padding: "8px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        resize: "none",
                        fontSize: "14px",
                      }}
                      rows="3"
                    />
                  </div>
                </div>
              }
              footer={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <button
                    onClick={() => setShowModal(false)}
                    style={{
                      padding: "6px 18px",
                      borderRadius: "20px",
                      border: "1px solid #ccc",
                      background: "#fff",
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    onClick={submitReqHigherDiscount}
                    disabled={loading}
                    style={{
                      padding: "6px 20px",
                      borderRadius: "20px",
                      border: "none",
                      background: "#ff4fa3",
                      color: "#fff",
                    }}
                  >
                    {loading ? "Submitting..." : "Send"}
                  </button>
                </div>
              }
            />


          </>
      }




      <ReusableModal
        class="systemsettimg-modal"
        show={isModalPackageEffected}
        modalContentClass="systemsetting-modal"
        showCloseButton={false}
        title={
          <>
            The selected service/package has been updated or deleted. Your existing contract is currently In Progress.
            <br />
            <br />

            Please choose how you want to proceed.
          </>
        }
        footer={
          <div className="justify-content-center d-flex w-100">
            <button
              type="button"
              className="btn btn-outline-pink rounded w-auto me-3"
              style={{
                fontSize: "12px",
                height: "53px"
              }}
              onClick={() => prevStep(false)}
            >
              Create Contract With Updated Pricing
            </button>
            <button
              type="button"
              className="btn btn-pink rounded w-auto"
              style={{
                fontSize: "12px",
                height: "53px"
              }}
              onClick={() => setIsModalPackageEffected(false)}
            >
              Proceed With Existing Contract
            </button>


          </div>
        }
      />


      <ReusableModal
        show={showAttachmentModal}
        onClose={() => { setShowAttachmentModal(false); setSelectedAttachments([]) }}
        modalsize="lg"
        title={
          <span className="text-pink fw-bold" style={{ fontWeight: "600", fontSize: "20px" }}>Select Attachments</span>
        }
        body={
          <>

            {formData?.attachments?.map((file, index) => (
              <div key={index}>
                <input
                  type="checkbox"
                  checked={selectedAttachments.some(
                    (f) => f.name === file.name && f.lastModified === file.lastModified
                  )}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedAttachments([...selectedAttachments, file]);
                    } else {
                      setSelectedAttachments(
                        selectedAttachments.filter(
                          (f) =>
                            !(
                              f.name === file.name &&
                              f.lastModified === file.lastModified
                            )
                        )
                      );
                    }
                  }}
                />
                <label style={{ marginLeft: "8px" }}>
                  {file.name}
                </label>
              </div>
            ))}



          </>
        }
        footer={
          <>
            <button className="btn btn-pink"
              onClick={() => {
                setFormData({
                  ...formData,
                  attachments: selectedAttachments,
                });
                setShowAttachmentModal(false);
                selectedAttachmentsStore(selectedAttachments);
              }}>
              Done
            </button>
            <button
              className="btn btn-outline-secondary"
              onClick={() => { setShowAttachmentModal(false); setSelectedAttachments([]) }}>
              Cancel
            </button>

          </>
        }
      />






    </div>


  );
};

export default StepFour;
